<template>
  <!-- 最外层容器：整个大屏的根节点 -->
  <div class="data-screen">
    <!-- 星空背景动画容器 -->
    <div class="star-bg"></div>

    <!-- ====================== 顶部数据看板（你红框里填的内容） ====================== -->
    <div class="top-widget">
      <!-- 左侧：大屏主标题 -->
      <div class="top-left">
        <h2>企业运营数据可视化大屏</h2>
      </div>

      <!-- 中间：3个核心数据卡片 -->
      <div class="top-mid">
        <div class="card">
          <p>总订单</p>
          <h3>{{ targetOrder }}</h3>
        </div>
        <div class="card">
          <p>活跃用户</p>
          <h3>{{ targetUser }}</h3>
        </div>
        <div class="card">
          <p>总销售额</p>
          <h3>¥ 1,286,500</h3>
        </div>
      </div>

      <!-- 右侧：实时显示当前时间 -->
      <div class="top-right">
        <span>{{ nowTime }}</span>
      </div>
    </div>

    <!-- ====================== 主体内容区域（所有图表模块） ====================== -->
    <div class="content">
      <!-- 左侧列：两个小图表 -->
      <div class="left">
        <!-- 销售统计模块（带科技边框） -->
        <dv-border-box-11 title="销售统计">
          <div class="chart-wrapper">
            <div id="saleChart" class="chart"></div>
          </div>
        </dv-border-box-11>

        <!-- 用户来源饼图模块 -->
        <dv-border-box-11 title="用户来源">
          <div class="chart-wrapper">
            <div id="userChart" class="chart"></div>
          </div>
        </dv-border-box-11>
      </div>

      <!-- 中间：全国数据地图（最大模块） -->
      <div class="middle">
        <dv-border-box-11 title="全国数据地图">
          <div class="chart-wrapper map-wrapper">
            <div id="mapChart" class="chart map"></div>
          </div>
        </dv-border-box-11>
      </div>

      <!-- 右侧列：两个小图表 -->
      <div class="right">
        <!-- 趋势分析折线图 -->
        <dv-border-box-11 title="趋势分析">
          <div class="chart-wrapper">
            <div id="lineChart" class="chart"></div>
          </div>
        </dv-border-box-11>

        <!-- 业务统计柱状图 -->
        <dv-border-box-11 title="业务统计">
          <div class="chart-wrapper">
            <div id="businessChart" class="chart"></div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
  </div>
</template>

<script>
// 引入ECharts核心库（绘制图表）
import * as echarts from 'echarts'
// 引入中国地图JSON数据
import china from 'echarts/map/json/china.json'
// 注册中国地图，让ECharts认识china地图
echarts.registerMap('china', china)

export default {
  // 数据定义：所有变量都在这里声明
  data() {
    return {
      nowTime: '',        // 实时时间字符串
      orderCount: 0,      // 当前订单数（动画用）
      userCount: 0,       // 当前用户数（动画用）
      targetOrder: 1286,  // 最终订单数目标值
      targetUser: 894     // 最终用户数目标值
    }
  },
  // 页面挂载完成：一进页面就执行的方法
  mounted() {
    this.initCharts()      // 初始化所有4个图表
    this.initMap()         // 初始化中国地图
    this.getTime()         // 启动实时时间
    this.startCountUp()    // 启动数字滚动动画
    this.initStarBg()      // 生成星空背景
    // 监听窗口大小变化，自动适配图表大小
    window.addEventListener('resize', this.resizeAllCharts)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeAllCharts)
  },
  methods: {
    resizeAllCharts() {
      echarts.getInstanceByDom(document.getElementById('saleChart'))?.resize()
      echarts.getInstanceByDom(document.getElementById('userChart'))?.resize()
      echarts.getInstanceByDom(document.getElementById('lineChart'))?.resize()
      echarts.getInstanceByDom(document.getElementById('businessChart'))?.resize()
      echarts.getInstanceByDom(document.getElementById('mapChart'))?.resize()
    },

    initCharts() {
      // 1. 销售统计 —— 柱状图
      let saleChart = echarts.init(document.getElementById('saleChart'))
      saleChart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 30, 60, 0.9)',
          borderColor: '#00ffff',
          borderWidth: 1,
          textStyle: { color: '#fff' },
          formatter: '{b}<br/>销量：{c}'
        },
        xAxis: {
          type: 'category',
          data: ['周一', '周二', '周三', '周四', '周五'],
          axisLine: { lineStyle: { color: '#00ffff' } },
          axisLabel: { color: '#fff' }
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: '#00ffff' } },
          axisLabel: { color: '#fff' },
          splitLine: { lineStyle: { color: 'rgba(0,255,255,0.2)' } }
        },
        grid: { top: '30%', bottom: '20%', left: '15%', right: '15%' },
        series: [{
          type: 'bar',
          data: [120, 230, 224, 180, 150],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00ffff' },
              { offset: 1, color: '#0066ff' }
            ])
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ffffff' },
                { offset: 1, color: '#00ccff' }
              ])
            }
          }
        }]
      })

      // 2. 用户来源 —— 饼图
      let userChart = echarts.init(document.getElementById('userChart'))
      userChart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 30, 60, 0.9)',
          borderColor: '#00ffff',
          borderWidth: 1,
          textStyle: { color: '#fff' },
          formatter: '{b}<br/>占比：{d}%'
        },
        grid: { top: '15%', bottom: '15%', left: '15%', right: '15%' },
        series: [{
          type: 'pie',
          radius: ['25%', '55%'],
          center: ['50%', '58%'],
          data: [
            { name: '安卓', value: 30, itemStyle: { color: '#00ffff' } },
            { name: '苹果', value: 50, itemStyle: { color: '#0099ff' } },
            { name: '网页', value: 20, itemStyle: { color: '#66ccff' } }
          ],
          label: { color: '#fff' }
        }]
      })

      // 3. 趋势分析 —— 折线图
      let lineChart = echarts.init(document.getElementById('lineChart'))
      lineChart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 30, 60, 0.9)',
          borderColor: '#00ffff',
          borderWidth: 1,
          textStyle: { color: '#fff' },
          formatter: '{b}<br/>数值：{c}'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月'],
          axisLine: { lineStyle: { color: '#00ffff' } },
          axisLabel: { color: '#fff' }
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: '#00ffff' } },
          axisLabel: { color: '#fff' },
          splitLine: { lineStyle: { color: 'rgba(0,255,255,0.2)' } }
        },
        grid: { top: '30%', bottom: '20%', left: '15%', right: '15%' },
        series: [{
          type: 'line',
          data: [10, 20, 30, 25, 40],
          lineStyle: { color: '#00ffff', width: 3 },
          itemStyle: { color: '#00ffff' },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0,255,255,0.5)' },
              { offset: 1, color: 'rgba(0,255,255,0)' }
            ])
          },
          emphasis: {
            itemStyle: {
              color: '#ffffff',
              shadowBlur: 10,
              shadowColor: '#00ffff'
            }
          }
        }]
      })

      // 4. 业务统计 —— 柱状图
      let businessChart = echarts.init(document.getElementById('businessChart'))
      businessChart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 30, 60, 0.9)',
          borderColor: '#00ffff',
          borderWidth: 1,
          textStyle: { color: '#fff' },
          formatter: '{b}<br/>销量：{c}'
        },
        xAxis: {
          type: 'category',
          data: ['产品A', '产品B', '产品C', '产品D'],
          axisLine: { lineStyle: { color: '#00ffff' } },
          axisLabel: { color: '#fff' }
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: '#00ffff' } },
          axisLabel: { color: '#fff' },
          splitLine: { lineStyle: { color: 'rgba(0,255,255,0.2)' } }
        },
        grid: { top: '30%', bottom: '20%', left: '15%', right: '15%' },
        series: [{
          type: 'bar',
          data: [320, 302, 301, 334],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#66ccff' },
              { offset: 1, color: '#0066ff' }
            ])
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ffffff' },
                { offset: 1, color: '#00ccff' }
              ])
            }
          }
        }]
      })
    },

    // 地图初始化
    initMap() {
      let mapChart = echarts.init(document.getElementById('mapChart'))
      mapChart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,20,47,0.8)',
          textStyle: { color: '#fff' }
        },
        visualMap: {
          min: 0,
          max: 1000,
          left: 20,
          bottom: 20,
          text: ['高', '低'],
          calculable: true,
          inRange: { color: ['#0066ff', '#0099ff', '#00ffff'] },
          textStyle: { color: '#fff' }
        },
        geo: {
          map: 'china',
          roam: true,
          zoom: 1.2,
          top: '10%', bottom: '10%', left: '10%', right: '10%',
          label: { show: true, color: '#fff' },
          itemStyle: { areaColor: '#041429', borderColor: '#00ffff' }
        },
        series: [{
          type: 'effectScatter',
          coordinateSystem: 'geo',
          data: [
            { name: '北京', value: [116.46, 39.92, 800] },
            { name: '上海', value: [121.48, 31.22, 950] },
            { name: '广州', value: [113.23, 23.16, 880] },
            { name: '深圳', value: [114.07, 22.62, 920] },
            { name: '合肥', value: [117.27, 31.86, 750] }
          ],
          symbolSize: val => val[2] / 100,
          showEffectOn: 'render',
          rippleEffect: { brushType: 'stroke' },
          itemStyle: { color: '#00ffff', shadowBlur: 10, shadowColor: '#00ffff' }
        }]
      })
    },

    // 数字滚动动画
    startCountUp() {
      let step = 10
      const timer = setInterval(() => {
        if (this.orderCount < this.targetOrder) this.orderCount += step
        if (this.userCount < this.targetUser) this.userCount += step
        if (this.orderCount >= this.targetOrder && this.userCount >= this.targetUser) clearInterval(timer)
      }, 20)
    },

    // 星空背景
    initStarBg() {
      const bg = document.querySelector('.star-bg')
      for (let i = 0; i < 200; i++) {
        const star = document.createElement('div')
        star.className = 'star'
        star.style.left = Math.random() * 100 + '%'
        star.style.top = Math.random() * 100 + '%'
        star.style.animationDelay = Math.random() * 3 + 's'
        bg.appendChild(star)
      }
    },

    // 实时时间
    getTime() {
      setInterval(() => {
        this.nowTime = new Date().toLocaleString()
      }, 1000)
    }
  }
}
</script>

<style scoped>
/* 全局基础样式 */
* {
  box-sizing: border-box;
}

/* 最外层：允许移动端纵向滚动，同时禁止横向溢出 */
.data-screen {
  width: 100%;
  min-height: 100vh;
  background: #041429;
  margin: 0;
  padding: 0;
  color: #fff;
  position: relative;
  overflow-x: hidden;  /* 只禁止横向溢出 */
  overflow-y: auto;    /* 关键：开启纵向滚动 */
}

/* 星空背景：改为fixed，滚动时背景固定不动，体验更好 */
.star-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none; /* 让背景不影响点击/滑动 */
}
.star {
  position: absolute;
  width: 2px;
  height: 2px;
  background: #fff;
  border-radius: 50%;
  opacity: 0.5;
  animation: twinkle 3s infinite ease-in-out;
}
@keyframes twinkle {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

/* ====================== 顶部看板样式 ====================== */
.top-widget {
  position: relative;
  z-index: 1;
  width: 96%;
  margin: 10px auto 0;
  padding: 15px 20px;
  background: rgba(0, 30, 60, 0.4);
  border: 1px solid rgba(0, 200, 255, 0.3);
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 180, 255, 0.2);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.top-left h2 {
  font-size: clamp(16px, 4vw, 24px);
  color: #00ffff;
  text-shadow: 0 0 10px #00ffff;
  margin: 0;
  letter-spacing: 1px;
}
.top-mid {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.card {
  width: clamp(80px, 22vw, 160px);
  text-align: center;
  padding: 8px 5px;
  border: 1px solid rgba(0, 200, 255, 0.25);
  border-radius: 6px;
  background: rgba(0, 40, 80, 0.3);
}
.card p {
  font-size: 12px;
  color: #ccc;
  margin: 0 0 4px 0;
}
.card h3 {
  font-size: clamp(14px, 4vw, 22px);
  color: #00ffff;
  margin: 0;
  text-shadow: 0 0 6px #00ffff;
}
.top-right {
  font-size: clamp(12px, 3vw, 16px);
  color: #00ffff;
  text-shadow: 0 0 6px #00ffff;
}

/* ====================== 主体布局 ====================== */
.content {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 10px 15px 30px; /* 底部加padding，避免最后一个图表被遮挡 */
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.left, .middle, .right {
  width: 100% !important;
}

/* 图表容器：让图表居中 */
.chart-wrapper {
  width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chart {
  width: 100%;
  height: 100%;
}

/* 地图边框拉高 + 内部垂直居中 */
:deep(.middle dv-border-box-11) {
  height: auto !important;
  min-height: 450px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.map-wrapper {
  width: 96%;
  height: 450px;
}
.map {
  width: 100%;
  height: 100%;
}

/* ====================== 修正版媒体查询：大屏端恢复原尺寸 ====================== */
@media (min-width: 992px) {
  .data-screen {
    overflow: hidden; /* 大屏端恢复全屏效果，禁止滚动 */
  }
  .top-widget {
    height: 110px;
    padding: 0 20px;
  }
  .top-left h2 {
    font-size: 24px;
  }
  .card {
    width: 160px;
    padding: 10px 0;
  }
  .card p {
    font-size: 14px;
  }
  .card h3 {
    font-size: 22px;
  }
  .content {
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    padding: 10px 20px;
    height: calc(100vh - 155px);
  }
  .left, .right {
    width: 22% !important;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .middle {
    width: 50% !important;
  }
  .chart-wrapper {
    height: 220px;
  }
  .map-wrapper {
    height: 520px;
  }
  :deep(.middle dv-border-box-11) {
    height: 720px !important;
  }
}
</style>